import { render, staticRenderFns } from "./FocusBadge.vue?vue&type=template&id=5fb9aa3c&"
import script from "./FocusBadge.vue?vue&type=script&lang=js&"
export * from "./FocusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports